import React from "react";
import {
  ChevronUp,
  PlusCircle,
  RotateCcw
} from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import AddSalesReturns from "../../core/modals/sales/addsalesreturns";
import EditSalesRetuens from "../../core/modals/sales/editsalesretuens";
import Table from "../../core/pagination/datatable";
import { setToogleHeader } from "../../core/redux/action";
import { currencyFormatter, dateFormatter, formatPhoneNumber } from "../../utils/helperFunctions";
import useSalesReturn from "./useSalesReturn";

const SalesReturn = () => {

  const { values } = useSalesReturn()

  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  const columns = [
    {
      title: "Date",
      dataIndex: "return_date",
      render: (text) => dateFormatter(text),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      render: (text) => text || "-",
    },
    {
      title: "Return Amount",
      dataIndex: "total_refund",
      render: (text) => currencyFormatter(text),
    },
    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   key: "actions",
    //   render: () => (
    //     <div className="action-table-data">
    //       <div className="edit-delete-action">
    //         <Link
    //           className="me-2 p-2"
    //           to="#"
    //           data-bs-toggle="modal"
    //           data-bs-target="#edit-sales-new"
    //         >
    //           <i data-feather="edit" className="feather-edit"></i>
    //         </Link>
    //         <Link className="confirm-text p-2" to="#">
    //           <i
    //             data-feather="trash-2"
    //             className="feather-trash-2"
    //             onClick={showConfirmationAlert}
    //           ></i>
    //         </Link>
    //       </div>
    //     </div>
    //   ),
    // },
  ];
  // const MySwal = withReactContent(Swal);

  // const showConfirmationAlert = () => {
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonColor: "#00ff00",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonColor: "#ff0000",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       MySwal.fire({
  //         title: "Deleted!",
  //         text: "Your file has been deleted.",
  //         className: "btn btn-success",
  //         confirmButtonText: "OK",
  //         customClass: {
  //           confirmButton: "btn btn-success",
  //         },
  //       });
  //     } else {
  //       MySwal.close();
  //     }
  //   });
  // };
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Sales Return List</h4>
                <h6>Manage your Returns</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <i data-feather="printer" className="feather-printer" />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-added"
                data-bs-toggle="modal"
                data-bs-target="#add-sales-new"
              >
                <PlusCircle className="me-2" />
                Add New Sales Return
              </Link>
            </div>
          </div>
          {/* /product list */}
          {
            !values?.loading &&
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Invoice No.</h6>
                      <p className="mb-0 mt-1 fw-bold">
                        #{values?.data?.invoice_no}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Sale Date</h6>
                      <p className="mb-0 mt-1">
                        {dateFormatter(values?.data?.sale_date)}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Biller Name</h6>
                      <p className="mb-0 mt-1">
                        {values?.data?.user?.full_name}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Status</h6>
                      <p className="mb-0 mt-1">
                        {values?.data?.status}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Customer Name</h6>
                      <p className="mb-0 mt-1">
                        {values?.data?.customer?.full_name}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Customer Phone</h6>
                      <p className="mb-0 mt-1">
                        {formatPhoneNumber(values?.data?.customer?.phone)}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Represtative Name</h6>
                      <p className="mb-0 mt-1">
                        {values?.data?.customer?.user?.full_name}
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Payment Status</h6>
                      <p className="mb-0 mt-1">
                        {values?.data?.payment_status}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Shipping</h6>
                      <p className="mb-0 mt-1">
                        {currencyFormatter(values?.data?.shipping)}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Discount</h6>
                      <p className="mb-0 mt-1">
                        {currencyFormatter(values?.data?.discount)}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Tax</h6>
                      <p className="mb-0 mt-1">
                        {currencyFormatter(values?.data?.sale_tax)}
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="details-item">
                      <h6>Total Amount</h6>
                      <p className="mb-0 mt-1">
                        {currencyFormatter(values?.data?.total_amount)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-responsive">
                <Table
                  total={values?.sales_return_data?.total}
                  loading={values.loading}
                  columns={columns}
                  // onPageChange={handlePageChange}
                  // pagination={pageValues}
                  dataSource={values?.sales_return_data?.data || []}
                />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <AddSalesReturns id={values?.data?.id} data={values?.data?.sale_items} />
      <EditSalesRetuens />
    </div>
  );
};

export default SalesReturn;
